import { css } from '@emotion/core';
import { Theme } from 'features/Theme';

const styles = {
  walletButton: (theme: Theme) => css`
    padding: 0 ${theme.mui.spacing(1)}px;
  `,
};

export default styles;
